exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".exitButtom{\r\n\theight: 1.2rem;\r\n\tborder-radius: 0px;\r\n\tline-height: 1.2rem;\r\n\tcolor: #FF6666;\r\n\tfont-size: 0.3rem;\r\n\twidth: 100%;\r\n\tposition: absolute;\r\n\tbottom: 0;left: 0;\r\n\tbackground-color: #fff;\r\n\ttext-align: center;\r\n}\r\n", ""]);

// exports
